var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessFilledWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#0D873C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9992,
    cy: 27.9992,
    r: 16.8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 4.66797C15.1446 4.66797 4.66797 15.1446 4.66797 28.0013C4.66797 40.858 15.1446 51.3346 28.0013 51.3346C40.858 51.3346 51.3346 40.858 51.3346 28.0013C51.3346 15.1446 40.858 4.66797 28.0013 4.66797ZM39.1546 22.6346L25.9246 35.8646C25.598 36.1913 25.1546 36.378 24.688 36.378C24.2213 36.378 23.778 36.1913 23.4513 35.8646L16.848 29.2613C16.1713 28.5846 16.1713 27.4646 16.848 26.788C17.5246 26.1113 18.6446 26.1113 19.3213 26.788L24.688 32.1546L36.6813 20.1613C37.358 19.4846 38.478 19.4846 39.1546 20.1613C39.8313 20.838 39.8313 21.9346 39.1546 22.6346Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFilledWhite);
export default __webpack_public_path__ + "static/media/SuccessFilledWhite.3c156302b236a2145a31ea1dd53e37c6.svg";
export { ForwardRef as ReactComponent };